/* Daily Cart v4.20.8 (Oct 27): on photo (personalized) product pages, picking a color, finish or size shows that variant's own picture.
   Nothing happens on load (the lifestyle photo stays first). Runs after dc.js. Never throws. */
(function () {
  try {
    var root = document.querySelector('[data-dc-product]');
    if (!root) return;
    var form = root.querySelector('form[data-native="true"]');
    var main = root.querySelector('.dc-gallery__main');
    var rawEl = root.querySelector('[data-variants]');
    if (!form || !main || !rawEl) return;
    var mh = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!mh) return;
    var handle = decodeURIComponent(mh[1]);
    var variants = JSON.parse(rawEl.textContent);
    var groups = [].slice.call(root.querySelectorAll('[data-option]'));
    var tr = root.querySelector('.dc-gallery__thumbs');
    var thumbs = tr ? [].slice.call(tr.querySelectorAll('[data-thumb]')) : [];
    var HID = 'dc-4208-hid';

    /* color pictures: media position (1-based) -> color name */
    var COLORS = {
      'custom-photo-sweatshirt': { 11: 'White', 12: 'Black', 13: 'Sand', 14: 'Sport Grey', 15: 'Light Pink' },
      'custom-photo-hoodie': { 12: 'White', 13: 'Black', 14: 'Sand', 15: 'Sport Grey', 16: 'Light Pink' },
      'kids-custom-photo-hoodie-matching-pet-or-family-photo-youth-hoodie': { 11: 'White', 12: 'Black', 13: 'Sport Grey', 14: 'Light Pink' },
      'custom-photo-tote-bag': { 9: 'Black', 11: 'Red' },
      'custom-photo-christmas-stocking': { 9: 'Red and Black/Natural', 10: 'White and Black/Natural' }
    };
    /* pictures that only show when their variant is picked (no thumbnail) */
    var HIDE = {
      'custom-framed-photo-canvas-your-favorite-photo-in-a-floating-frame-ready-to-hang': [3, 4, 5, 6, 7, 8, 9, 10]
    };
    var cfg = COLORS[handle] || null;
    var hidePos = [];
    if (cfg) Object.keys(cfg).forEach(function (k) { hidePos.push(+k); });
    if (HIDE[handle]) hidePos = hidePos.concat(HIDE[handle]);

    function fileOf(u) {
      u = String(u || '');
      try { return new URL(u, location.href).pathname.split('/').pop(); } catch (e) { return u.split('?')[0].split('/').pop(); }
    }
    function slidesAll() { return [].slice.call(main.querySelectorAll('.dc-gallery__slide')); }
    function slidesOrig() { return [].slice.call(main.querySelectorAll('.dc-gallery__slide:not([data-extra-slide])')); }
    function byPos(js, p) { for (var i = 0; i < js.media.length; i++) if (js.media[i].position === p) return js.media[i]; return null; }
    function srcOf(m) { return m.src || (m.preview_image && m.preview_image.src) || ''; }

    var jsP = null;
    function getJS() {
      if (!jsP) {
        jsP = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('no js'); return r.json(); })
          .catch(function () { return null; });
      }
      return jsP;
    }

    /* thumbnails of pictures that only show for their variant: keep the buttons in the DOM (dc.js pairs slides and thumbs by position), just hide them */
    function hideThumbs(js) {
      hidePos.forEach(function (p) {
        var m = byPos(js, p); if (!m) return;
        var f = fileOf(srcOf(m));
        thumbs.forEach(function (t) {
          var im = t.querySelector('img');
          if (im && fileOf(im.getAttribute('src')) === f) { t.style.display = 'none'; t.classList.add(HID); }
        });
      });
      counter();
    }

    function pickTarget(js) {
      var vals = groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
      var v = null;
      variants.forEach(function (x) {
        if (!v && vals.every(function (q, i) { return q === null || x.options[i] === q; })) v = x;
      });
      if (cfg) {
        var keys = Object.keys(cfg);
        for (var i = 0; i < keys.length; i++) {
          var name = cfg[keys[i]].toLowerCase();
          var hit = vals.some(function (q) { return q !== null && String(q).toLowerCase() === name; });
          if (hit) { var m = byPos(js, +keys[i]); if (m) return m; }
        }
      }
      if (v && js.media.length) {
        var jv = null;
        (js.variants || []).forEach(function (x) { if (x.id === v.id) jv = x; });
        var fm = jv && jv.featured_media;
        if (fm && fm.id !== js.media[0].id) {
          for (var k = 0; k < js.media.length; k++) if (js.media[k].id === fm.id) return js.media[k];
        }
      }
      return null;
    }

    function activate(slide) {
      slidesAll().forEach(function (s) { s.classList.remove('is-active'); });
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      slide.classList.add('is-active');
      var n = slidesOrig().indexOf(slide);
      if (n > -1 && thumbs[n]) thumbs[n].classList.add('is-active');
      var im = slide.querySelector('img'); if (im) im.setAttribute('loading', 'eager');
    }

    function showMedia(m) {
      var f = fileOf(srcOf(m)), slide = null;
      slidesAll().forEach(function (s) {
        var im = s.querySelector('img');
        if (!slide && im && fileOf(im.getAttribute('src')) === f) slide = s;
      });
      if (!slide) {
        var base = srcOf(m), sep = base.indexOf('?') > -1 ? '&' : '?';
        function w(n) { return base + sep + 'width=' + n; }
        slide = document.createElement('div');
        slide.className = 'dc-gallery__slide';
        slide.setAttribute('data-extra-slide', '');
        var im2 = document.createElement('img');
        im2.src = w(1400);
        im2.srcset = w(600) + ' 600w, ' + w(900) + ' 900w, ' + w(1200) + ' 1200w, ' + w(1400) + ' 1400w';
        im2.sizes = '(min-width: 900px) 55vw, 100vw';
        if (m.width) im2.width = m.width;
        if (m.height) im2.height = m.height;
        im2.alt = m.alt || document.title;
        slide.appendChild(im2);
        var ui = main.querySelector('.dc-gal-ui');
        main.insertBefore(slide, ui || null);
      }
      activate(slide);
    }

    var switched = false;
    function goFirst() {
      var o = slidesOrig();
      if (o.length) activate(o[0]);
    }

    function onChange() {
      getJS().then(function (js) {
        if (!js || !js.media) return;
        var m = pickTarget(js);
        if (m) { showMedia(m); switched = true; }
        else if (switched) { goFirst(); switched = false; }
      }).catch(function () {});
    }

    groups.forEach(function (g) {
      g.querySelectorAll('input').forEach(function (i) {
        i.addEventListener('change', function () { setTimeout(onChange, 0); });
      });
    });

    function curIndex() {
      var o = slidesOrig();
      for (var i = 0; i < o.length; i++) if (o[i].classList.contains('is-active')) return i;
      return 0;
    }

    /* dc.js show() only knows the original slides: clear an injected slide before it handles a thumb tap.
       The arrows and swipe click thumbs by code; if that lands on a hidden thumb, move on to the next visible one. */
    if (tr) {
      tr.addEventListener('click', function (e) {
        try {
          var t = e.target && e.target.closest ? e.target.closest('[data-thumb]') : null;
          if (!t) return;
          if (!e.isTrusted && t.classList.contains(HID)) {
            e.stopImmediatePropagation(); e.preventDefault();
            var n = thumbs.indexOf(t), len = thumbs.length, cur = curIndex();
            var dir = n > cur ? 1 : -1;
            if (cur === 0 && n === len - 1) dir = -1; else if (cur === len - 1 && n === 0) dir = 1;
            for (var k = 0; k < len; k++) {
              if (!thumbs[n].classList.contains(HID)) { thumbs[n].click(); return; }
              n = (n + dir + len) % len;
            }
            return;
          }
          [].slice.call(main.querySelectorAll('[data-extra-slide].is-active')).forEach(function (s) { s.classList.remove('is-active'); });
        } catch (x) {}
      }, true);
    }

    /* photo counter (1 / 8): count only the pictures that have a thumbnail */
    function counter() {
      try {
        var c = main.querySelector('.dc-gal-count'); if (!c) return;
        var act = main.querySelector('.dc-gallery__slide.is-active');
        var o = slidesOrig(), vis = [];
        o.forEach(function (s, n) { if (!thumbs[n] || !thumbs[n].classList.contains(HID)) vis.push(s); });
        var i = vis.indexOf(act);
        if (i < 0) { c.style.visibility = 'hidden'; }
        else { c.style.visibility = ''; c.textContent = (i + 1) + ' / ' + vis.length; }
      } catch (x) {}
    }
    if ('MutationObserver' in window) {
      new MutationObserver(counter).observe(main, { attributes: true, attributeFilter: ['class'], subtree: true });
    }

    if (hidePos.length) getJS().then(function (js) { if (js && js.media) hideThumbs(js); });
  } catch (err) {}
})();